import RegisterPersonalDataError from './RegisterPersonalDataError';
class InvalidNationality extends RegisterPersonalDataError {
    constructor(nationality, options) {
        super(`Can not register nationality: ${nationality}`, options);
    }
}
export default InvalidNationality;
